// medSchedule — منطق جدول جرعات الدواء المشترك بين نموذجَي العيادة (إدخال + تعديل).
// النموذج: dosage = الجرعة لكل مرّة · freqCode = سيناريو التكرار · durationDays = مدّة العلاج.
//   عدد الجرعات      = سقف(معدّل يوميّ × المدّة)
//   الكمّية الإجماليّة = الجرعة/مرّة × عدد الجرعات   ← تُخصم من المخزون (= quantity)
//   التكلفة          = الكمّية الإجماليّة × سعر الوحدة (price × quantity)
// التسميات عبر مفاتيح i18n (labelKey) لتُترجَم في المكوّن.
// أدوية pricing_mode='flat' (3.4.87 — مثل المغذّي، غير قابلة للتجزئة): التكرار والمدّة يبقيان
// كما هما (بطلب المستخدم — ما زالا مفيدَين طبّيًّا وتُحسَب منهما عدد الجرعات/العبوات
// المصروفة)، فقط "الجرعة/مرّة" لا معنى لها لعنصر لا يُقسَّم — تُفرَض 1 (عبوة كاملة/جرعة).

export const FREQ_OPTIONS = [
  { code: 'qd', labelKey: 'clinicMed.freq.qd', perDay: 1 },
  { code: 'bid', labelKey: 'clinicMed.freq.bid', perDay: 2 },
  { code: 'tid', labelKey: 'clinicMed.freq.tid', perDay: 3 },
  { code: 'qid', labelKey: 'clinicMed.freq.qid', perDay: 4 },
  { code: 'q2d', labelKey: 'clinicMed.freq.q2d', perDay: 1 / 2 },
  { code: 'q3d', labelKey: 'clinicMed.freq.q3d', perDay: 1 / 3 },
  { code: 'qwk', labelKey: 'clinicMed.freq.qwk', perDay: 1 / 7 },
  { code: 'q2wk', labelKey: 'clinicMed.freq.q2wk', perDay: 1 / 14 },
  { code: 'qmo', labelKey: 'clinicMed.freq.qmo', perDay: 1 / 30 },
];

export const perDayOf = (code) => FREQ_OPTIONS.find((o) => o.code === code)?.perDay || 0;
export const labelKeyOf = (code) => FREQ_OPTIONS.find((o) => o.code === code)?.labelKey || '';

// أقرب سيناريو لقيمة freq_per_day مخزّنة (لإعادة اختيار القائمة عند التعديل).
export const codeFromPerDay = (perDay) => {
  const v = Number(perDay) || 0;
  if (!v) return '';
  let best = FREQ_OPTIONS[0];
  for (const o of FREQ_OPTIONS) {
    if (Math.abs(o.perDay - v) < Math.abs(best.perDay - v)) best = o;
  }
  return best.code;
};

export const computeLine = (med) => {
  const price = parseFloat(med.price) || 0;
  // pricing_mode='flat': الجرعة/مرّة مفروضة 1 (عبوة كاملة) — التكرار والمدّة يُحسبان بنفس
  // المعادلة كأي دواء آخر، فالكمّية الإجماليّة = عدد الجرعات = عدد العبوات المصروفة.
  const dose = med.pricingMode === 'flat' ? 1 : parseFloat(med.dosage) || 0;
  const perDay = perDayOf(med.freqCode);
  const days = parseFloat(med.durationDays) || 0;
  const administrations = perDay > 0 && days > 0 ? Math.ceil(perDay * days) : 0;
  const totalUnits = +(dose * administrations).toFixed(3);
  const cost = +(totalUnits * price).toFixed(2);
  return { administrations, totalUnits, cost, price, perDay };
};

// وصف نصّيّ مقروء للجدول (يُحفظ في حقل duration). يُمرَّر t للترجمة (لقطة بلغة الحافظ).
export const scheduleText = (med, t) => {
  const days = parseFloat(med.durationDays) || 0;
  const key = labelKeyOf(med.freqCode);
  const freq = t && key ? t(key) : key;
  const daysWord = t ? t('clinicMed.daysShort') : 'يوم';
  if (med.pricingMode === 'flat') return `${freq} · ${days} ${daysWord}`.trim();
  return `${med.dosage || ''} ${med.unit || ''} · ${freq} · ${days} ${daysWord}`.trim();
};
